<!-- ─────────────────────────────────────────────────────────────────────────
  Desktop popover (Spartan hlm-popover → BrnPopover → CDK connected overlay)
  Used when NOT on mobile, or when fullscreenOnMobile is false.
────────────────────────────────────────────────────────────────────────── -->
@if (!useMobileOverlay()) {
<div class="popover-wrapper">
  <hlm-popover [state]="desktopState()" [attachTo]="triggerEl" [closeOnOutsidePointerEvents]="overlayClickable()"
    [closeOnBackdropClick]="overlayClickable()" (stateChanged)="handleDesktopStateChanged($event)">
    <!-- Visible trigger — handles click / hover to open the overlay -->
    <div #triggerRef class="popover-trigger" [class.pointer-events-none]="disabled()" [class.opacity-50]="disabled()"
      (click)="trigger() === 'click' ? onDesktopTriggerClick() : null"
      (mouseenter)="trigger() === 'hover' ? onDesktopTriggerMouseEnter() : null"
      (mouseleave)="trigger() === 'hover' ? onDesktopTriggerMouseLeave() : null">
      <ng-container *ngTemplateOutlet="triggerTemplate" />
    </div>

    <!-- Popover panel rendered in a CDK overlay via the portal structural directive -->
    <hlm-popover-content
      *hlmPopoverPortal
      [class]="'bg-white flex flex-col ' + class()"
      [style.width]="width()"
      (mouseenter)="trigger() === 'hover' ? onDesktopPanelMouseEnter() : null"
      (mouseleave)="trigger() === 'hover' ? onDesktopPanelMouseLeave() : null"
    >
      @if (headerTemplate) {
      <div class="popover-header">
        <ng-container *ngTemplateOutlet="headerTemplate" />
      </div>
      }
      <div class="popover-body" [style.maxHeight]="maxHeight()"
        [style.overflowY]="showScrollbar() ? 'auto' : 'visible'">
        <ng-container *ngTemplateOutlet="bodyTemplate" />
      </div>
      @if (footerTemplate) {
      <div class="popover-footer">
        <ng-container *ngTemplateOutlet="footerTemplate" />
      </div>
      }
    </hlm-popover-content>
  </hlm-popover>
</div>
}

<!-- ─────────────────────────────────────────────────────────────────────────
  Mobile overlay (app-bottom-sheet with global bottom-sheet position)
  Used when on mobile (< 1024px) AND fullscreenOnMobile is true.
────────────────────────────────────────────────────────────────────────── -->
@if (useMobileOverlay()) {
<div class="popover-trigger" [class.pointer-events-none]="disabled()" [class.opacity-50]="disabled()"
  (click)="onMobileTriggerClick()">
  <ng-container *ngTemplateOutlet="triggerTemplate" />
</div>

<app-bottom-sheet #mobileSheet [state]="mobileDialogState()" [headerTemplate]="headerTemplate"
  [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate" [overlayClickable]="overlayClickable()"
  [maxHeight]="maxHeight() !== 'auto' ? maxHeight() : '85dvh'" [showScrollbar]="showScrollbar()" [class]="class()"
  (stateChanged)="handleMobileStateChanged($event)" />
}
